<template>
  <div>
    <b-dropdown variant="-ternary btn--outline no--arr btn--dots" size="-small" text="⋮" right>
      <b-dropdown-item-button v-if="showRestart" @click="openRestart=true">{{$t('history.actions.restart')}}</b-dropdown-item-button>
      <b-dropdown-item-button v-if="showDetails" @click="handleOpenDetails">{{$t('history.actions.details')}}</b-dropdown-item-button>
      <b-dropdown-item-button @click="openNotes = true">{{$t('history.actions.notes')}}</b-dropdown-item-button>
    </b-dropdown>

    <b-modal v-model="openDetails" modal-class="modal--edit modal--data modal--details">
      <job-details :printer-id="job.printer_id" :job="job" :show-timelaps="detailsShowTimelaps"></job-details>
      <template v-slot:modal-footer="{ cancel, ok }">
        <div class="modal__footer--left">
          <b-button variant="-gray" @click="cancel()">
            {{$t('buttons.close')}}
          </b-button>
        </div>
        <div class="modal__footer--right">
          <b-button variant="-primary" @click="handleOpenToolpathViewer()">
            {{$t('printers.modal.jobDetails.openToolpath')}}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal v-model="openNotes" modal-class="modal--notes" hide-footer>
      <job-notes :job-id="job.id"></job-notes>
    </b-modal>

    <b-modal ref="restartPopup" v-model="openRestart" modal-class="modal--move" size="lg" hide-footer>
      <choose-printer-for-action modal-class="modal--clear" :jobId="job.id" :printerId="job.printer_id" action="restart" @close="handleCloseRestart"></choose-printer-for-action>
    </b-modal>
  </div>
</template>

<script>
  import JobDetails from "../printers/modal/JobDetails";
  import JobNotes from "../printers/modal/JobNotes";
  import ChoosePrinterForAction from "../printers/modal/ChoosePrinterForAction";
  import ApplicationMixin from "@/mixins/application";
  import FileMixin from "@/mixins/file";

  export default {
    name: 'dashboard-history-action-buttons',
    props: ['job'],
    mixins: [FileMixin, ApplicationMixin],
    components: {
      ChoosePrinterForAction,
      JobDetails,
      JobNotes
    },
    data() {
      return {
        openDetails: false,
        detailsShowTimelaps: false,
        openNotes: false,
        openRestart: false
      }
    },
    computed: {
      showRestart() {
        return this.job.status_id > 40;
      },
      showDetails() {
        return this.isGcodeFileType(this.job.file_type_id);
      }
    },
    methods: {
      handleCloseRestart() {
        this.$refs.restartPopup.hide();
      },
      handleOpenDetails() {
        this.detailsShowTimelaps = false;
        this.openDetails = true;
      },
      handleOpenToolpathViewer() {
        this.oldApps_showToolpathViewer(this.job.file_id, this.job.filename)
        this.openDetails = false;
      },
      handleOpenTimelaps() {
        this.detailsShowTimelaps = true;
        this.openDetails = true;
      }
    }
  }
</script>
